export function getStartOfYear(date: Date | undefined): Date | undefined {
    if (!date) {
        return undefined;
    }
    return new Date(date.getFullYear(), 0, 1, 0, 0, 0, 0);
}

export function getStartOfPreviousYear(date: Date | undefined): Date | undefined {
    if (!date) {
        return undefined;
    }
    return new Date(date.getFullYear() - 1, 0, 1, 0, 0, 0, 0);
}